export default __webpack_public_path__ + "static/media/space green.71276c89.png";